import axiosInstance from '../axios/axios-instance';
import { SignedTileDto } from 'shared/dto/project/signed-tile.dto';

export const profileSurveyApi = {
  /**
   * Get the profile survey for the current user.
   * @returns The user profile survey.
   */
  async getProfileSurveyByUserCountry(): Promise<SignedTileDto> {
    const response = await axiosInstance.get('/profile-survey');
    return response.data as SignedTileDto;
  },

  /**
   * Checks if a user has completed the profile survey.
   *
   * @returns True if the user has completed the profile survey, false otherwise
   */
  async hasProfileSurveyCompleted(): Promise<boolean> {
    const response = await axiosInstance.get<boolean>('/profile-survey/completed');
    return response.data;
  },
};
